import { makeStyles } from '@material-ui/core';

export const getProposalPreviewDefaultCoverPageContentStyles = makeStyles(
  () => ({
    titleContainer: {
      paddingBottom: '35mm',
    },
  }),
);
